import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import { useWindowSize } from '@app/hooks';
import { useProductDirectoryHeader } from '@app/pages/Warehouses/ProductDirectory/hooks';

export const ProductDirectoryHeader = () => {
  const { goToAddProduct } = useProductDirectoryHeader();
  const { isMobile } = useWindowSize();

  return (
    <Button
      className={isMobile ? 'full-width' : ''}
      type="primary"
      onClick={goToAddProduct}
      icon={<PlusOutlined />}
    >
      Добавить товар
    </Button>
  );
};
